import * as React from 'react'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import Container from '@mui/material/Container'

import TextEditorImportDialog from './TextEditorImport'
import MindMapImportDialog from './MindMapImport'
import PKMImportDialog from './PKMImport'
import ShortTextImportDialog from './ShortTextImport'
import AiImportDialog from './AiImport'
import MarketImportDialog from './MarketImport'
import LinkImportDialog from './LinkImport'
import TextFilesImportDialog from './TextFilesImport'
import CSVFileImportDialog from './CSVFileImport'
import JSONFileImportDialog from './JSONFileImportMultiStep'
import GexfFileImportDialog from './GexfFileImport'
import NetworkXImportDialog from './NetworkXImport'
import GoogleImportDialog from './GoogleImport'
import TwitterImportDialog from './TwitterImport'
import ScholarImportDialog from './ScholarImport'
import PatentsImportDialog from './PatentsImport'
import ScienceImportDialog from './ScienceImport'
import KeywordsImportDialog from './KeywordsImport'
import SEOImportDialog from './SEOImport'
import NicheImportDialog from './NicheImport'
import NewsImportDialog from './NewsImport'
import RssImportDialog from './RssImport'
import URLsImportDialog from './UrlsImport'
import YouTubeKeywordsImportDialog from './YouTubeKeywordsImport'
import YouTubeCommentsImportDialog from './YouTubeCommentsImport'
import YouTubeSubtitlesImportDialog from './YouTubeSubtitlesImport'
import YouTubeChannelImportDialog from './YouTubeChannelImport'
import AmazonProductsImportDialog from './AmazonProductsImport'
import AmazonReviewsImportDialog from './AmazonReviewsImport'
import AiTopicsImportDialog from './AiTopicsImport'
import AiOntologiesImportDialog from './AiOntologiesImport'
import AiIdeaImportDialog from './AiIdeaImport'
import AiChatImportDialog from './AiChatImport'
import SyncImportDialog from './SyncImport'
import MainImportDialog from './MainImport'
import AllImportDialog from './AllImport'
import TextImportDialog from './TextImport'
import SearchResultsImportDialog from './SearchResultsImport'
import AiGraphImportDialog from './AiGraphImport'

import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportProvider } from './SubImportContext'

import { sendToAnalytics } from '../../Analytics'

export default function ImportDialog({
    presetContext,
    open,
    type,
    onClose,
    presetSearchString,
    presetFiles,
}) {
    const { username } = React.useContext(UserContext)

    React.useEffect(() => {
        if (type)
            sendToAnalytics({
                userId: username,
                event: 'open_import_dialog',
                data: { importType: type },
            })
    }, [type])

    return (
        <>
            <SubImportProvider>
                {type === 'textEditor' && (
                    <TextEditorImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></TextEditorImportDialog>
                )}
                {type === 'mindmapImport' && (
                    <MindMapImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></MindMapImportDialog>
                )}
                {type === 'pkmImport' && (
                    <PKMImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></PKMImportDialog>
                )}
                {type === 'textImport' && (
                    <TextImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></TextImportDialog>
                )}
                {type === 'shortTextImport' && (
                    <ShortTextImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></ShortTextImportDialog>
                )}
                {type === 'aiImport' && (
                    <AiImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiImportDialog>
                )}
                {type === 'marketImport' && (
                    <MarketImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></MarketImportDialog>
                )}
                {type === 'linkImport' && (
                    <LinkImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></LinkImportDialog>
                )}
                {type === 'textFilesImport' && (
                    <TextFilesImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></TextFilesImportDialog>
                )}
                {type === 'mdFilesImport' && (
                    <TextFilesImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetMode="mdFilesImport"
                    ></TextFilesImportDialog>
                )}
                {type === 'srtFilesImport' && (
                    <TextFilesImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetMode="srtFilesImport"
                    ></TextFilesImportDialog>
                )}
                {type === 'csvFileImport' && (
                    <CSVFileImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetFiles={presetFiles}
                    ></CSVFileImportDialog>
                )}
                {type === 'jsonFileImport' && (
                    <JSONFileImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetFiles={presetFiles}
                    ></JSONFileImportDialog>
                )}
                {type === 'gexfFileImport' && (
                    <GexfFileImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetFiles={presetFiles}
                    ></GexfFileImportDialog>
                )}
                {type === 'networkxFileImport' && (
                    <NetworkXImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetFiles={presetFiles}
                    ></NetworkXImportDialog>
                )}
                {type === 'google' && (
                    <GoogleImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></GoogleImportDialog>
                )}
                {type === 'searchResultsImport' && (
                    <SearchResultsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></SearchResultsImportDialog>
                )}
                {type === 'twitter' && (
                    <TwitterImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></TwitterImportDialog>
                )}
                {type === 'keywords' && (
                    <KeywordsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></KeywordsImportDialog>
                )}
                {type === 'seo' && (
                    <SEOImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></SEOImportDialog>
                )}
                {type === 'niche' && (
                    <NicheImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></NicheImportDialog>
                )}
                {type === 'scholar' && (
                    <ScholarImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></ScholarImportDialog>
                )}
                {type === 'patents' && (
                    <PatentsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></PatentsImportDialog>
                )}
                {type === 'science' && (
                    <ScienceImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></ScienceImportDialog>
                )}
                {type === 'urls' && (
                    <URLsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></URLsImportDialog>
                )}
                {type === 'youtubeKeywords' && (
                    <YouTubeKeywordsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></YouTubeKeywordsImportDialog>
                )}
                {type === 'youtubeVideos' && (
                    <YouTubeKeywordsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        type="youtubeVideos"
                    ></YouTubeKeywordsImportDialog>
                )}
                {type === 'youtubeComments' && (
                    <YouTubeCommentsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></YouTubeCommentsImportDialog>
                )}
                {type === 'youtubeSubtitles' && (
                    <YouTubeSubtitlesImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></YouTubeSubtitlesImportDialog>
                )}
                {type === 'youtubeChannel' && (
                    <YouTubeChannelImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></YouTubeChannelImportDialog>
                )}
                {type === 'amazonProducts' && (
                    <AmazonProductsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AmazonProductsImportDialog>
                )}
                {type === 'amazonReviews' && (
                    <AmazonReviewsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AmazonReviewsImportDialog>
                )}
                {type === 'news' && (
                    <NewsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></NewsImportDialog>
                )}
                {type === 'rss' && (
                    <RssImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></RssImportDialog>
                )}
                {(type === 'aiTopics' || type === 'aiTopicsLlm') && (
                    <AiTopicsImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiTopicsImportDialog>
                )}
                {type === 'aiOntologies' && (
                    <AiOntologiesImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiOntologiesImportDialog>
                )}
                {type === 'aiGraphs' && (
                    <AiGraphImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiGraphImportDialog>
                )}
                {type === 'aiIdea' && (
                    <AiIdeaImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiIdeaImportDialog>
                )}
                {type === 'aiChat' && (
                    <AiChatImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AiChatImportDialog>
                )}
                {type === 'syncImport' && (
                    <SyncImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></SyncImportDialog>
                )}
                {type === 'textMining' && (
                    <TextImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetMode="textMining"
                    ></TextImportDialog>
                )}
                {type === 'qualitativeImport' && (
                    <TextImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                        presetMode="qualitativeImport"
                    ></TextImportDialog>
                )}
                {type === 'allImport' && (
                    <AllImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></AllImportDialog>
                )}
                {type === 'import' && (
                    <MainImportDialog
                        open={open}
                        onClose={onClose}
                        fullWidth={true}
                        presetContext={presetContext}
                        presetSearchString={presetSearchString}
                    ></MainImportDialog>
                )}
            </SubImportProvider>
        </>
    )
}

function renderImportOptionsMenu(menuItems) {
    const theme = useTheme()

    return (
        <Container
            sx={{
                py: 1,
                [theme.breakpoints.up('sm')]: {
                    pl: 0,
                },
            }}
            maxWidth={false}
        >
            <Grid
                container
                rowSpacing={3}
                justifyContent="flex-start"
                columnSpacing={3}
                alignItems="flex-start"
                pr={0}
            >
                {menuItems.map(card => (
                    <Grid item key={card.name} alignItems="flex-start" pr={0}>
                        <MenuItem {...card} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
}
